import React, {Component, ReactNode} from 'react'
import { Box, RadioGroup, RadioProps, Radio } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {InfoArea, InfoOutlinedIcon} from './NatAdminApplicationCommon'
import {LeftColumnFlexContainer, LeftTopRowFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {HAVE_OR_NOT} from '../../../../../CodeMaster'
import styled from 'styled-components'
import {Colors} from '../../../../../styledComponents/Constants'
import {StyledPre} from '../../../../../styledComponents/adminPage/StyledPre'

interface Props {
    onChange: (value: string) => void
}

interface State {
    petClubExistence: string
}

export default class NatAdminApplicationApprovalPetChairmanDelegateComponent extends Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props)
        this.state = {
            petClubExistence: '',
        }
        this.handleChangePetClubRadio = this.handleChangePetClubRadio.bind(this)
    }

    handleChangePetClubRadio(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({petClubExistence: event.target.value}, () => {
            this.props.onChange(this.state.petClubExistence)
        })
    }

    render(): ReactNode {
        const {petClubExistence} = this.state

        const data = [
            {
                label: 'ペットクラブ委員長に申請の内容を確認したので、承認・却下の代行を行います。',
                value: HAVE_OR_NOT.HAVE.value,
                info: true,
            },
            {
                label: 'ペットクラブがないため、承認代行を行います。',
                value: HAVE_OR_NOT.NOT.value,
                info: false,
            },
        ]

        return (
            <>
                <Box mb={'16px'}>
                    <StyledPre>
                        申請の承認・却下操作をペットクラブ委員長の代わりに行います。
                    </StyledPre>
                </Box>
                <Box mb={'2px'}>
                    <RadioGroup
                        onChange={this.handleChangePetClubRadio}
                    >
                        {
                            data.map((item, i) =>
                                <Box mb={i !== data.length - 1 ? '8px' : undefined} key={i}>
                                    <PetBackdrop selected={item.value === petClubExistence}>
                                        <LeftTopRowFlexContainer>
                                            <PetRadio
                                                value={item.value}
                                                checked={item.value === petClubExistence}
                                            />
                                            <LeftColumnFlexContainer>
                                                <Box>
                                                    {item.label}
                                                </Box>
                                                {item.info &&
                                                    <Box mt={'8px'}>
                                                        <PetInfoArea selected={item.value === petClubExistence}>
                                                            <Box padding={'20px'}><InfoOutlinedIcon/></Box>
                                                            <Box>
                                                                代行で申請の承認または却下を行いますと、処理した内容が記録されます。<br/>
                                                                間違いがないように操作してください。
                                                            </Box>
                                                        </PetInfoArea>
                                                    </Box>
                                                }
                                            </LeftColumnFlexContainer>
                                        </LeftTopRowFlexContainer>
                                    </PetBackdrop>
                                </Box>,
                            )
                        }
                    </RadioGroup>
                </Box>
            </>
        )
    }
}

const PetBackdrop = styled.label<{ selected: boolean }>`
  background-color: ${props => {
    if (props.selected) {
      return 'rgba(0, 112, 176, 0.15)'
    } else {
      return 'rgba(241, 241, 241, 1)'
    }
  }};
  display: inline-block;
  cursor: pointer;
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  line-height: 21px;
`

const PetRadio = withStyles({
    root: {
        padding: 0,
        marginLeft: '-3px',
        marginRight: '10px',
        color: Colors.Body,
        '&$checked': {
            color: Colors.Primary,
        },
        '& .MuiSvgIcon-root': {
            fontSize: '22px',
        },
    },
    checked: {},
})
((props: RadioProps) => <Radio color="default" {...props} />)

const PetInfoArea = styled(InfoArea)<{ selected: boolean }>`
  background-color: ${props => {
    if (props.selected) {
      return 'transparent'
    } else {
      return `${Colors.Background}`
    }
  }};
`